// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__2OklD","totalPrice":"Price_totalPrice__GFJCE"};